import { render, staticRenderFns } from "./BrandingTab.vue?vue&type=template&id=44f5ec66&scoped=true"
import script from "./BrandingTab.vue?vue&type=script&lang=js"
export * from "./BrandingTab.vue?vue&type=script&lang=js"
import style0 from "./BrandingTab.vue?vue&type=style&index=0&id=44f5ec66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f5ec66",
  null
  
)

export default component.exports